module.exports = __webpack_public_path__ + "static/media/service_subject_4.49533066.png";